export default __webpack_public_path__ + "static/media/thumbnail.19862688.png";